(function () {
  'use strict'

  require('dynamic-bind-html')

  require('./scss/app.scss')
  require('./scss/app-vcard-dynamic.scss')

  const MODULE_NAME = 'thismoment.card.component.appVcardDynamic'
  const templateUrl = require('./tpl/app-vcard-dynamic.html')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml',
      require('../../common/component/video')
    ])
    .config(appVcardDynamicConfig)
    .component('thismomentAppVcardDynamic', {
      require: {
        parent: '^thismomentCard'
      },
      bindings: {
        item: '<'
      },
      templateUrl: templateUrl,
      controller: appVcardDynamicController
    })

  appVcardDynamicConfig.$inject = ['$compileProvider']
  function appVcardDynamicConfig ($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel|sms):/)
  }

  appVcardDynamicController.$inject = ['$element', '$timeout', '$window', 'SdkConfig', 'ExpandedContent']
  function appVcardDynamicController ($element, $timeout, $window, SdkConfig, ExpandedContent) {
    const vm = this

    vm.$onInit = vcardDynamicInit
    vm.isMobile = SdkConfig.get('is_mobile')
    vm.expandVideoVcard = expandVideoVcard
    vm.getDomain = getDomain
    vm.isModernVcard = isModernVcard

    function vcardDynamicInit () {
      // NOTE: Injected variables are reassigned as Angular deals with
      // different things, so we're caching a local copy of our $element
      // for later shenanigans (SEE: setBaseFont, below).
      const element = $element

      vm.trackEvent = vm.parent.trackEvent

      // NOTE: This is here because the vCard font-size needs to be dynamically
      // set to be proportional to the container width.
      $timeout(setBaseFont(), 100)
      angular.element($window).bind('resize', setBaseFont)

      if (angular.isUndefined(vm.item.app.user.vcard)) {
        return
      }

      // prepend w/ string to convert possible int to string
      let phoneNumber = '' + vm.item.app.user.vcard.phone_selected
      phoneNumber = phoneNumber.replace(/\D/g, '')
      phoneNumber = phoneNumber.substr(phoneNumber.length - 10)
      // display phone as (DDD) DDD-DDDD
      vm.displayPhoneNumber = '(' + phoneNumber.substr(0, 3) + ') ' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6, 4)

      const emailParams = {}
      if (vm.item.app.user.vcard.cc_addresses) {
        emailParams.cc = vm.item.app.user.vcard.cc_addresses
      }
      if (vm.item.app.reply_subject) {
        emailParams.subject = vm.item.app.reply_subject
      }
      if (vm.item.app.reply_body) {
        emailParams.body = vm.item.app.reply_body
          .replace('__FIRSTNAME__', vm.item.app.user.vcard.first_name)
          .replace('__EMAIL__', vm.item.app.user.vcard.email)
      }
      vm.mailto = 'mailto:' + vm.item.app.user.vcard.email + '?' + Object.keys(emailParams).map(key => {
        return key + '=' + encodeURIComponent(emailParams[key].replace(/\n/g, '\r\n'))
      }).join('&')
      vm.scheduleMeetingLink = normalizeHttpUrl(
        vm.item.app.user.vcard.schedule_meeting_link || vm.item.app.user.vcard.vcard_schedule_meeting_link
      )
      vm.showMeetingLinkVcard = !!vm.scheduleMeetingLink

      const queryParams = $window.location.search
      if (queryParams.includes('vcardVideoId')) {
        const contentId = queryParams.substring(queryParams.indexOf('=') + 1)
        if (contentId === vm.item.app.user.vcard.profile_video_content_item.id) {
          expandVideoVcard()
        }
      }

      function setBaseFont () {
        $timeout(() => {
          vm.styles = {
            container: {
              'font-size': Math.floor(element[0].getBoundingClientRect().width * 0.04) + 'px'
            }
          }
        }, 0)
      }
    }

    function expandVideoVcard () {
      const vcardVideo = vm.item.app.user.vcard.profile_video_content_item
      vcardVideo.extended = {}
      ExpandedContent.open(vcardVideo, {
        card_date_display: false,
        card_description_display: false,
        card_share_display: false,
        card_source_display: false,
        card_title_display: false
      })
    }

    function getDomain () {
      // Extract the domain from current window location
      const hostname = $window.location.hostname

      // Handle different environments
      if (hostname.includes('thismomentlocal.com')) {
        return 'thismomentlocal.com'
      } else if (hostname.includes('thismomentdev2.com')) {
        return 'thismomentdev2.com'
      } else if (hostname.includes('thismomentone.com')) {
        return 'thismomentone.com'
      } else {
        // Default fallback
        return 'thismomentone.com'
      }
    }

    function isModernVcard () {
      // Always use modern vcard for all users (legacy code kept for reference)
      return true
      // Old conditional logic (commented out):
      // const allowedEmails = [
      //   'ericmeyer+sparktest@thismoment.com',
      //   'roger.doyle@verizon.com',
      //   'matthew.horton@verizonwireless.com',
      //   'latrisha.x.gray@verizon.com',
      //   'dion.gardner@verizon.com',
      //   'lexi.wade@verizon.com',
      //   'joyce.abrams@verizon.com'
      // ]
      // return vm.item.app.user.vcard.email && allowedEmails.includes(vm.item.app.user.vcard.email.toLowerCase())
    }

    function normalizeHttpUrl (url) {
      if (!url || !url.trim()) {
        return null
      }

      const trimmedUrl = url.trim()
      if (/^(https?:\/\/|mailto:|tel:|sms:)/i.test(trimmedUrl)) {
        return trimmedUrl
      }

      return 'https://' + trimmedUrl
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/app-vcardDynamic.js